import { combineEpics, Epic, ofType } from 'redux-observable';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';
import * as types from './types';
import { mergeMap } from 'rxjs/operators';
import { notify } from '../../../services/notifier.service';

const AuthEpic: Epic = (action$, store) => {
  return action$.pipe(
    ofType(types.AUTH_USER_LOGIN_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .post('users/login', action.payload)
        .then((res) => {
          return { type: types.AUTH_USER_LOGIN_RECEIVE, payload: res.data };
        })
        .catch((err) => {
          notify({
            title: 'Helaas',
            html: `De combinatie van de ingevoerde gebruikersnaam en wachtwoord is onjuist`,
            type: 'error'
          });
          return { type: types.AUTH_USER_LOGIN_ERROR };
        })
    )
  );
};

const GetDriverEpic: Epic = (action$, store) => {
  return action$.pipe(
    ofType(types.AUTH_USER_DRIVER_REQUEST),
    mergeMap(() =>
      loopBackApi()
        .get('drivers/by-user')
        .then((res) => {
          return { type: types.AUTH_USER_DRIVER_RECEIVE, payload: res.data };
        })
        .catch((err) => {
          return { type: types.AUTH_USER_DRIVER_ERROR };
        })
    )
  );
};

const AuthLogOutEpic: Epic = (action$, store) => {
  return action$.pipe(
    ofType(types.AUTH_USER_LOGOUT_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .post('users/logout', action.payload)
        .then((res) => ({
          type: types.AUTH_USER_LOGOUT_RECEIVE
        }))
        .catch((err) => ({
          type: types.AUTH_USER_LOGOUT_ERROR
        }))
    )
  );
};

export const authEpics = combineEpics(AuthEpic, AuthLogOutEpic, GetDriverEpic);
